import React, { memo, ReactNode } from 'react';

import Modal from '@plasma/ui.layout.modal';
import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';

import EditableTable from '../../components/edit-table';
import LoadingComponent from '../../components/Loding-component/LoadingComponent';
import TopBarThemed from '../../components/top-bar-themed';
import useAllPersonnelHook from './all-personnel.hook';
import * as styled from './all-personnel.styles';
import PersonnelForm from './personnel-form';
import themes from './themes';

export interface AllPersonnelProps {
  children?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

type Props = AllPersonnelProps & ThemeOverride;

function AllPersonnel(props: Props) {
  const { children, className, style, size, themeMode } = props;

  const {
    t,
    uniqueEntities,
    columnNames,
    pageLoading,
    flagOptions,
    stateData,
    formMode,
    formValues,
    emailError,
    updateFormField,
    handleZipCodeChange,
    handleContactNo1Change,
    handleContactNo2Change,
    openAddModal,
    openEditModal,
    closeModal,
    handleSaveForm,
    handleDeletePersonnel,
  } = useAllPersonnelHook(props);

  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.AllPersonnel className={`all-personnel ${className ?? ''}`.trim()} style={style}>
        {pageLoading && <LoadingComponent />}
        <TopBarThemed topHeading={t('manage-personnel')} />

        <styled.HeaderToolbar>
          <styled.NormalPlasmaButton title={t('add-new-personnel')} onClick={openAddModal} />
        </styled.HeaderToolbar>

        <Modal
          title={formMode === 'edit' ? 'Edit existing Personnel' : t('add-new-personnel')}
          width="55vw"
          okText={formMode === 'edit' ? 'Save Personnel' : t('save-personnel')}
          cancelText="Cancel"
          visible={formMode !== null}
          onCancel={closeModal}
          onOk={handleSaveForm}
          destroyOnClose
        >
          <PersonnelForm
            values={formValues}
            onChange={updateFormField}
            onZipCodeChange={handleZipCodeChange}
            onContactNo1Change={handleContactNo1Change}
            onContactNo2Change={handleContactNo2Change}
            emailError={emailError}
            flagOptions={flagOptions}
            entityOption={uniqueEntities}
            t={t}
          />
        </Modal>

        <styled.TableContainer>
          <EditableTable
            tableData={stateData}
            tableColumns={columnNames}
            Table_Header=""
            hiddenColumns={[
              'id',
              'companyId',
              'continent',
              'country',
              'province',
              'state',
              'address1',
              'address2',
              'address3',
              'zipCode',
            ]}
            handleSave={handleDeletePersonnel}
            showActions_ext
            allowSelection
            saveReturnType={'row'}
            ButtonsVisible={{
              Edit: false,
              MoveUp: false,
              InsertUp: false,
              InsertDown: false,
              MoveDown: false,
              Delete: true,
            }}
            handleSelection={openEditModal}
            clearTheSelection={false}
            showOnlyDeleteIcon
          />
        </styled.TableContainer>
      </styled.AllPersonnel>
    </ThemeProvider>
  );
}

export default memo(AllPersonnel) as unknown as typeof AllPersonnel;
